import { action, withoutPayload, withPayload } from '../../../utility/redux';
import { ItemList, ListParams } from '../../../types/main';
import { ItemId, PromotionCode } from '../../../types/items';

// List actions
export const getPromotionCodeListRequest = action(
  'GET_PROMOTION_CODE_LIST_REQUEST',
  withPayload<ListParams>(),
);

export const getPromotionCodeListSuccess = action(
  'GET_PROMOTION_CODE_LIST_SUCCESS',
  withPayload<ItemList<PromotionCode>>(),
);

export const getPromotionCodeListFail = action(
  'GET_PROMOTION_CODE_LIST_FAIL',
  withoutPayload,
);

export const setPromotionCodeListDirty = action(
  'SET_PROMOTION_CODE_LIST_DIRTY',
  withPayload<boolean>(),
);

export const clearPromotionCodeList = action(
  'CLEAR_PROMOTION_CODE_LIST',
  withoutPayload,
);

// Single actions

export const deletePromotionCodeRequest = action(
  'DELETE_PROMOTION_CODE_REQUEST',
  withPayload<ItemId>(),
);

export const deletePromotionCodeSuccess = action(
  'DELETE_PROMOTION_CODE_SUCCESS',
  withoutPayload,
);


export const deletePromotionCodeFail = action(
  'DELETE_PROMOTION_CODE_FAIL',
  withoutPayload,
);


export const initPromotionCodeRequest = action(
  'INIT_PROMOTION_CODE_REQUEST',
  withoutPayload,
);

export const initPromotionCodeSuccess = action(
  'INIT_PROMOTION_CODE_SUCCESS',
  withPayload<PromotionCode>(),
);

export const initPromotionCodeFail = action(
  'INIT_PROMOTION_CODE_FAIL',
  withoutPayload,
);

export const resetCurrentPromotionCode = action(
  'RESET_CURRENT_PROMOTION_CODE',
  withoutPayload,
);

export const createPromotionCodeRequest = action(
  'CREATE_PROMOTION_CODE_REQUEST',
  withPayload<PromotionCode>(),
);
export const createPromotionCodeSuccess = action(
  'CREATE_PROMOTION_CODE_SUCCESS',
  withPayload<PromotionCode>(),
);
export const createPromotionCodeFail = action(
  'CREATE_PROMOTION_CODE_FAIL',
  withoutPayload,
);

export const savePromotionCodeRequest = action(
  'SAVE_PROMOTION_CODE_REQUEST',
  withPayload<PromotionCode>(),
);
export const savePromotionCodeSuccess = action(
  'SAVE_PROMOTION_CODE_SUCCESS',
  withPayload<PromotionCode>(),
);
export const savePromotionCodeFail = action(
  'SAVE_PROMOTION_CODE_FAIL',
  withoutPayload,
);

export const getPromotionCodeRequest = action(
  'GET_PROMOTION_CODE_REQUEST',
  withPayload<ItemId>(),
);
export const getPromotionCodeSuccess = action(
  'GET_PROMOTION_CODE_SUCCESS',
  withPayload<PromotionCode>(),
);
export const getPromotionCodeFail = action(
  'GET_PROMOTION_CODE_FAIL',
  withoutPayload,
);

// Verification
export const validatePromotionCodeWithProductRequest = action(
  'VALIDATE_PROMOTION_CODE_WITH_PRODUCT_REQUEST',
  withPayload<string>(),
);

export const validatePromotionCodeWithProductSuccess = action(
  'VALIDATE_PROMOTION_CODE_WITH_PRODUCT_SUCCESS',
  withPayload<PromotionCode>(),
);

export const validatePromotionCodeWithProductFail = action(
  'VALIDATE_PROMOTION_CODE_WITH_PRODUCT_Fail',
  withoutPayload,
);

export const clearValidationPromotionCodeWIthProduct = action(
  'CLEAR_VALIDATION_PROMOTION_CODE_WITH_PRODUCT',
  withoutPayload,
);

export const applyPromotionCodeToActiveSubscriptionRequest = action(
  'APPLY_PROMOTION_CODE_TO_ACTIVE_SUBSCRIPTION_REQUEST',
  withPayload<{userId: number; promotionCode: string}>(),
);

export const applyPromotionCodeToActiveSubscriptionSuccess = action(
  'APPLY_PROMOTION_CODE_TO_ACTIVE_SUBSCRIPTION_SUCCESS',
  withoutPayload,
);

export const applyPromotionCodeToActiveSubscriptionFail = action(
  'APPLY_PROMOTION_CODE_TO_ACTIVE_SUBSCRIPTION_FAIL',
  withoutPayload,
);
